import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider } from "./store";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingChat from "./components/FloatingChat";
import HomeFinal from "./pages/HomeFinal";
import V1 from "./pages/variants/V1";
import V2 from "./pages/variants/V2";
import V3 from "./pages/variants/V3";
import V4 from "./pages/variants/V4";
import V5 from "./pages/variants/V5";
import VariantsIndex from "./pages/variants/Index";
import ProductList from "./pages/ProductList";
import ProductDetail from "./pages/ProductDetail";
import UltraAI from "./pages/UltraAI";
import BookDemo from "./pages/BookDemo";
import { BlogList, BlogPost } from "./pages/Blog";
import Contact from "./pages/Contact";
import Support from "./pages/Support";
import Warranty from "./pages/Warranty";
import WarrantyRequest from "./pages/WarrantyRequest";
import WarrantyTracking from "./pages/WarrantyTracking";
import TechnicalSupportRequest from "./pages/TechnicalSupportRequest";
import TechnicalSupportTracking from "./pages/TechnicalSupportTracking";
import FAQ from "./pages/FAQ";
import Cart from "./pages/Cart";
import { CheckoutSuccess, CheckoutCancel } from "./pages/Checkout";
import PixCheckout from "./pages/PixCheckout";
import UsdtCheckout from "./pages/UsdtCheckout";
import { Wishlist, Compare } from "./pages/WishlistCompare";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Layout({ children, noChat }) {
  const location = useLocation();
  const disableChat = noChat || location.pathname.startsWith("/support") || location.pathname.startsWith("/book");
  return (
    <>
      <Header />
      {children}
      <Footer />
      {!disableChat && <FloatingChat />}
    </>
  );
}

// Wrapper for Ultra AI category URL → UltraAI page
function ProductCategoryRouter() {
  // Delegate to ProductList; special-case ultra_ai slug
  return <ProductListOrUltra />;
}

function ProductListOrUltra() {
  const path = window.location.pathname.toLowerCase();
  if (path.includes("sharkx-ultra-ai-electric-jetski") || path.includes("ultra_ai") || path.includes("ultra-ai")) {
    return <UltraAI />;
  }
  return <ProductList />;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Layout><HomeFinal /></Layout>} />
            <Route path="/v" element={<Layout><VariantsIndex /></Layout>} />
            <Route path="/v1" element={<Layout><V1 /></Layout>} />
            <Route path="/v2" element={<Layout><V2 /></Layout>} />
            <Route path="/v3" element={<Layout><V3 /></Layout>} />
            <Route path="/v4" element={<Layout><V4 /></Layout>} />
            <Route path="/v5" element={<Layout><V5 /></Layout>} />
            <Route path="/home-final" element={<Layout><HomeFinal /></Layout>} />
            <Route path="/products" element={<Navigate to="/products/efoils" replace />} />
            <Route path="/products/SharkX-Ultra-AI-electric-jetski" element={<Layout><UltraAI /></Layout>} />
            <Route path="/products/sharkx-ultra-ai-electric-jetski" element={<Layout><UltraAI /></Layout>} />
            <Route path="/products/ultra_ai" element={<Layout><UltraAI /></Layout>} />
            <Route path="/products/:category" element={<Layout><ProductList /></Layout>} />
            <Route path="/product/:slug" element={<Layout><ProductDetail /></Layout>} />
            <Route path="/ultra-ai" element={<Layout><UltraAI /></Layout>} />
            <Route path="/book" element={<Layout><BookDemo /></Layout>} />
            <Route path="/book-demo" element={<Layout><BookDemo /></Layout>} />
            <Route path="/blog" element={<Layout><BlogList /></Layout>} />
            <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/warranty" element={<Layout><Warranty /></Layout>} />
            <Route path="/warranty/request" element={<Layout><WarrantyRequest /></Layout>} />
            <Route path="/warranty/request/:id" element={<Layout><WarrantyTracking /></Layout>} />
            <Route path="/faq" element={<Layout><FAQ /></Layout>} />
            <Route path="/support" element={<Layout><Support /></Layout>} />
            <Route path="/support/technical-request" element={<Layout><TechnicalSupportRequest /></Layout>} />
            <Route path="/support/technical-request/:id" element={<Layout><TechnicalSupportTracking /></Layout>} />
            <Route path="/cart" element={<Layout><Cart /></Layout>} />
            <Route path="/checkout/success" element={<Layout><CheckoutSuccess /></Layout>} />
            <Route path="/checkout/cancel" element={<Layout><CheckoutCancel /></Layout>} />
            <Route path="/checkout/pix-success" element={<Layout><PixCheckout /></Layout>} />
            <Route path="/checkout/usdt/:orderId" element={<Layout><UsdtCheckout /></Layout>} />
            <Route path="/wishlist" element={<Layout><Wishlist /></Layout>} />
            <Route path="/compare" element={<Layout><Compare /></Layout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<Admin />} />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
